import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_6v6o5jk4x7: FaireBrandEntity = {
  token: "b_6v6o5jk4x7",
  type: "brand",
  name: "Louisville Brands",
  avatarUrl:
    "https://cdn.faire.com/fastly/ab61837911d487d557a24efc318cbc516cbc67a09ac14a61c04e6607a8079d10.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/72a64d130debac4ae8c47a070cb14a6f5e48ab4953afa45e2bca67bbdaba6e03.png",
  logoUrl:
    "https://cdn.faire.com/fastly/ab61837911d487d557a24efc318cbc516cbc67a09ac14a61c04e6607a8079d10.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/72a64d130debac4ae8c47a070cb14a6f5e48ab4953afa45e2bca67bbdaba6e03.png",
  location: "Louisville, KY, USA",
  minimumOrderDollars: 40,
  rating: 5,
  reviewCount: 26,
  isTopShop: true,
  isInsider: true,
  description:
    "We're thrilled to welcome you to Louisville Brands, an expansion of the purveyors of plant-based snacks, Louisville Jerky, you know and love - now with even more high-quality munchies. Protein packed Gym Snack and wholesome Pumps are the newest additions, and alongside our delicious vegan jerky, there's something for everyone.\n\nGluten-Free Certified, Non-GMO Verified, Made in the USA, Great Source of Protein, Clean Ingredients, Animal & Cruelty Free\n\nOur facility is SQF (Safe Quality Food) Certified",
  meta: {
    source: "api",
    importedAt: "2026-05-05T05:28:45.228Z",
    importedBy: "entity-db-cli",
  },
};
